<div class="myPurchase-dialog-container">
    <div class="myPurchase-dialog-header">
        {{ title }}
    </div>
    <div class="myPurchase-dialog-content outer-frame">
        <mat-label class="label">{{ inputLabel }} <span *ngIf="!isRequired">(optional)</span> <span
                *ngIf="isRequired">*</span></mat-label>
        <form class="example-form">
            <mat-form-field class="comment">
                <textarea [formControl]="commentControl" [required]="isRequired" class="comment-area" matInput
                    placeholder="Insert your comments" maxlength="1500"></textarea>
                <mat-hint align="end" class="hint">{{ characterCount}}/1500</mat-hint>
            </mat-form-field>
        </form>
    </div>
    <div class="myPurchase-dialog-actions">
        <div mat-dialog-actions>
            <app-button class="padBtn" name="Cancel" mat-dialog-close></app-button>
            <app-button [disabled]="!commentControl.valid" class="padBtn actionBtn" [name]="okBtnLabel"
                type="flat-button" (click)="!disabled && onConfirm($event)" cdkFocusInitial [disabled]="disabled"></app-button>
        </div>
    </div>
</div>